import { generateShopAssociatedKey } from "#/utils/keyHandler"

//
const orderInfoShopKey = "yingqiyu_ziubao_shop_order_info_shop_key";
const orderInfoShopShopIdKey = "yingqiyu_ziubao_shop_order_info_shop_shop_id_key";

export const setOrderInfoShop = (shopId, data) => {
    /**
     * 
     */
    let orderInfoShopShopId = localStorage.getItem(orderInfoShopShopIdKey);

    if (orderInfoShopShopId != null) {
        clearOrderInfoShop(orderInfoShopShopId);
    }

    localStorage.setItem(orderInfoShopShopIdKey, shopId)

    /**
     * 
     */
    localStorage.setItem(generateShopAssociatedKey(shopId, orderInfoShopKey), JSON.stringify(data));
}

export const getOrderInfoShop = (shopId) => {
    let data = localStorage.getItem(generateShopAssociatedKey(shopId, orderInfoShopKey));

    if (data) {
        return JSON.parse(data);
    }

    return null;
}

export const clearOrderInfoShop = (shopId) => {
    localStorage.removeItem(generateShopAssociatedKey(shopId, orderInfoShopKey));
}

//
const orderDetailShopKey = "yingqiyu_ziubao_shop_order_detail_shop_key";
const orderDetailShopShopIdKey = "yingqiyu_ziubao_shop_order_detail_shop_shop_id_key";

export const setOrderDetailShop = (shopId, data) => {
    /**
     * 
     */
    let orderDetailShopShopId = localStorage.getItem(orderDetailShopShopIdKey);

    if (orderDetailShopShopId != null) {
        clearOrderDetailShop(orderDetailShopShopId);
    }

    localStorage.setItem(orderDetailShopShopIdKey, shopId)

    /**
     * 
     */
    localStorage.setItem(generateShopAssociatedKey(shopId, orderDetailShopKey), JSON.stringify(data));
}

export const getOrderDetailShop = (shopId) => {
    let data = localStorage.getItem(generateShopAssociatedKey(shopId, orderDetailShopKey));

    if (data) {
        return JSON.parse(data);
    }

    return null;
}

export const clearOrderDetailShop = (shopId) => {
    localStorage.removeItem(generateShopAssociatedKey(shopId, orderDetailShopKey));
}

//
const orderDetailProductListKey = "yingqiyu_ziubao_shop_order_detail_product_list_key";
const orderDetailProductListShopIdKey = "yingqiyu_ziubao_shop_order_detail_product_list_shop_id_key";

export const setOrderDetailProductList = (shopId, data) => {
    /**
     * 
     */
    let orderDetailProductListShopId = localStorage.getItem(orderDetailProductListShopIdKey);

    if (orderDetailProductListShopId != null) {
        clearOrderDetailProductList(orderDetailProductListShopId);
    }

    localStorage.setItem(orderDetailProductListShopIdKey, shopId)

    /**
     * 
     */
    localStorage.setItem(generateShopAssociatedKey(shopId, orderDetailProductListKey), JSON.stringify(data));
}

export const getOrderDetailProductList = (shopId) => {
    let data = localStorage.getItem(generateShopAssociatedKey(shopId, orderDetailProductListKey));

    if (data) {
        return JSON.parse(data);
    }

    return [];
}

export const clearOrderDetailProductList = (shopId) => {
    localStorage.removeItem(generateShopAssociatedKey(shopId, orderDetailProductListKey));
}